import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { useRouteMatch } from 'react-router-dom'

import { setChatVisible } from '@/reducers/baltoGPT/baltoGPT.redux'

import { CHANNEL_TYPE } from '@/utils/constants'
import { BaltoGPTChat } from './BaltoGPTChat'
import { BaltoGPTButton } from './BaltoGPTButton'

export const BaltoGPT = ({ externalCallIds } = {}) => {
  const dispatch = useDispatch()
  const { chatVisible } = useSelector((state) => state.baltoGPT)
  const { calls, callExplorer, filters = {} } = useSelector((state) => state.callSearch)
  const { messageThread } = useSelector((state) => state.messages)
  const currentUser = useSelector((state) => state.currentUser)
  const currentUserOrganization = useSelector((state) => state.currentOrganization)
  const playlist = useSelector((state) => state.playlists.playlist)
  const playlistCalls = playlist?.playlist_calls || []
  const { channel: selectedChannel } = filters
  const isCallDetailPage = useRouteMatch('/calls/:id')
  const isMessageDetailPage = useRouteMatch('/messages/:id')
  const isCallExplorerPage = useRouteMatch('/explorer')
  const isPlaylistPage = useRouteMatch('/playlists/:id')

  const channel = isMessageDetailPage
    ? selectedChannel || CHANNEL_TYPE.EMAIL
    : filters?.channel ?? CHANNEL_TYPE.CALL

  const isBaltoAdmin = currentUser.organizationid === 1
  const isHierarchyManager = !isBaltoAdmin && currentUser.hierarchy_manager

  // Balto Users have permissions to see BaltoGPT for all orgs.
  // Hierarchy managers can only see BaltoGPT for their org since they don't currently have BE permissions for other orgs.
  // One issue is that Balto Users will see BaltoGPT for all orgs, including orgs that don't have it enabled
  // TODO: Fetch organization properties of the filtered orgs and check if call_summarization_enabled for both Balto and Hierarchy
  // TODO: Allow Hierarchy Managers to use GPT for their sub orgs in the BE
  const hasCallSummarizationPermissions = isHierarchyManager
    ? filters.organizationId === currentUser.organizationid &&
      currentUserOrganization.call_summarization_enabled
    : currentUserOrganization.call_summarization_enabled

  let callIds = []
  if (isMessageDetailPage) {
    callIds = messageThread?.map((msg) => msg.call_id).filter((id) => Number.isInteger(id)) || []
  } else if (isPlaylistPage) {
    callIds = playlistCalls?.map((call) => call.call_id) || []
  } else if (externalCallIds) {
    callIds = externalCallIds
  } else {
    callIds = calls?.map((call) => call.call_id) || []
  }

  const shouldShowForCallExplorer =
    isCallExplorerPage && !isEmpty(callIds) && hasCallSummarizationPermissions
  const shouldShowForCallDetails = isCallDetailPage && !!callExplorer?.transcript
  const shouldShowForMessageDetails = isMessageDetailPage && !isEmpty(messageThread)
  const shouldShowForPlaylist =
    isPlaylistPage && !isEmpty(callIds) && hasCallSummarizationPermissions
  const shouldShowBaltoGPT =
    shouldShowForCallDetails ||
    shouldShowForCallExplorer ||
    shouldShowForPlaylist ||
    shouldShowForMessageDetails

  const handleToggleChatVisible = () => {
    dispatch(setChatVisible(!chatVisible))
  }

  if (!shouldShowBaltoGPT) {
    return null
  }
  const isDetailPage = shouldShowForCallDetails || shouldShowForMessageDetails
  return (
    <div id="balto-gpt" data-testid="balto-gpt-wrapper">
      {chatVisible && (
        <BaltoGPTChat
          handleToggleChatVisible={handleToggleChatVisible}
          isDetailPage={isDetailPage}
          callIds={callIds}
          channel={channel}
        />
      )}
      <BaltoGPTButton handleToggleChatVisible={handleToggleChatVisible} flush={isDetailPage} />
    </div>
  )
}
